/* eslint-disable react/destructuring-assignment */
import styled from '@emotion/styled'
import clsx from 'clsx'
import React from 'react'

type Props = {
  'aria-label'?: string
  checked: boolean
  'data-testid'?: string
  disabled?: boolean
  halfChecked?: boolean
  onChange: React.ChangeEventHandler<HTMLInputElement>
}

const Wrapper = styled.label`
  height: 16px;
  width: 16px;
  vertical-align: middle;
  align-items: center;
  display: block;
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  &:hover input ~ .checkmark {
    background-color: var(--White80);
  }
  input:checked ~ .checkmark {
    background-color: var(--Red-Dark);
    &:after {
      content: '';
      position: absolute;
      display: none;
    }
  }
  input:checked ~ .checkmark {
    &:after {
      display: block;
      left: 5px;
      top: 2px;
      width: 3.5px;
      height: 6.5px;
      border: solid white;
      border-width: 0 2px 2px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }
  input ~ .checkmark--half {
    background-color: var(--Red-Dark);
    &:after {
      content: '';
      position: absolute;
      display: block;
      background: white;
      width: 8px;
      height: 1px;
      transform: translate(4px, 7px);
    }
  }
`

const StyledCheckboxInput = styled.input`
  vertical-align: middle;
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`

const StyledCheckboxSpan = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 16px;
  width: 16px;
  background-color: var(--White90);
  border-radius: 4px;
`

export const Checkbox = (props: Props) => (
  <Wrapper
    className="checkbox"
    onClick={e => {
      e.stopPropagation()
    }}
  >
    <StyledCheckboxInput
      aria-label={props['aria-label']}
      checked={props.checked}
      data-testid={props['data-testid']}
      disabled={props.disabled}
      type="checkbox"
      onChange={props.onChange}
    />
    <StyledCheckboxSpan className={clsx('checkmark', { 'checkmark--half': props.halfChecked })} />
  </Wrapper>
)
